export default __webpack_public_path__ + "static/media/checkbox-checked-tata-neu.5e972aec.png";